export const OPEN_HAMBURGER_MENU = "OPEN_HAMBURGER_MENU";
export const OPEN_SEARCHBAR = "OPEN_SEARCHBAR";
export const MEMBER_UPDATED = "MEMBER_UPDATED";
export const IS_OPEN_LOGIN_FORM = "IS_OPEN_LOGIN_FORM";
export const STORY_HEADER_IN_VIEW = "STORY_HEADER_IN_VIEW";
export const TOAST_MESSAGE = "TOAST_MESSAGE";
